import React, { useEffect, useState } from "react";
import { getData } from "../api/reserves"; // Asume que este controlador está exportado
import {
  Typography,
  Box,
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Divider,
  Button,
  Modal,
} from "@mui/material";
import { QRCodeCanvas } from "qrcode.react"; // Cambié la importación aquí

function PanelPage() {
  const [data, setData] = useState(null); // Estado para almacenar los datos
  const [loading, setLoading] = useState(true); // Estado para gestionar la carga
  const [error, setError] = useState(null); // Estado para manejar errores
  const [modalOpen, setModalOpen] = useState(false);
  const [generatedLink, setGeneratedLink] = useState("");
  const [copied, setCopied] = useState(false);
  const modalStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const modalContentStyles = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
    maxWidth: "400px",
    margin: "0 auto",
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getData("Sheet1"); // Llamada a tu API
        console.log(response.data); // Revisa lo que recibes aquí
        if (response.data.success) {
          console.log(response.data.data);
          setData(response.data.data); // Actualiza los datos solo si la respuesta es exitosa
        } else {
          throw new Error(response.message || "Error al obtener los datos.");
        }
      } catch (error) {
        setError(error.message); // Captura errores
      } finally {
        setLoading(false); // Finaliza la carga
      }
    };

    fetchData();
  }, []);

  // Mostrar estados mientras los datos se cargan
  if (loading) {
    return <div>Loading...</div>;
  }
  const handleGenerateLink = (bedsidselect) => {
    console.log(bedsidselect);
    // Generamos el enlace utilizando el bedsid
    const baseUrl = `${window.location.origin}/#/completepay`;
    const params = new URLSearchParams({
      bedsid: bedsidselect, // Solo añadimos el bedsid al enlace
    });

    const fullUrl = `${baseUrl}?${params.toString()}`;
    setGeneratedLink(fullUrl);
    setModalOpen(true);
    setCopied(false);
  };

  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(generatedLink)
      .then(() => alert("Enlace copiado al portapapeles: " + generatedLink))
      .catch((err) => console.error("Error al copiar el enlace:", err));
  };
  const handleGoToPayment = () => {
    // Redirige a la página de pago
    window.location.href = generatedLink; // Sustituye con la URL de la página de pago
  };
  // Mostrar mensaje de error si ocurre alguno
  if (error) {
    return <div>Error: {error}</div>;
  }
  const totalPendiente = data.upcomingReservations
    .reduce((acc, res) => {
      const pagoPendiente = parseFloat(res["seña"].replace(/[^0-9.-]+/g, ""));
      return acc + (isNaN(pagoPendiente) ? 0 : pagoPendiente); // Verifica que el valor sea un número válido
    }, 0)
    .toFixed(2);
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
    }).format(value);
  };

  return (
    <Box sx={{ padding: 3, backgroundColor: "#Fff" }}>
      {/* Modal con QRCode */}
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        style={modalStyles}
      >
        <Box style={modalContentStyles}>
          <Typography variant="h6">Enlace Generado</Typography>
          {/* Usamos QRCodeCanvas */}
          <QRCodeCanvas value={generatedLink} size={200} />
          <Typography variant="body1" style={{ margin: "10px 0" }}>
            {generatedLink}
          </Typography>

          {/* Botón para copiar enlace */}
          <Button
            variant="outlined"
            color="primary"
            onClick={handleCopyLink}
            style={{ margin: "10px" }}
          >
            Copiar Enlace
          </Button>

          {copied && (
            <Typography
              variant="body2"
              style={{ color: "green", fontWeight: "bold" }}
            >
              ¡Enlace copiado al portapapeles!
            </Typography>
          )}

          {/* Botón para ir a la página de pago */}
          <Button
            variant="contained"
            color="secondary"
            onClick={handleGoToPayment}
            style={{ margin: "10px" }}
          >
            Ir a la Página de Pago
          </Button>

          {/* Botón para cerrar modal */}
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setModalOpen(false)}
            style={{ margin: "10px" }}
          >
            Cerrar
          </Button>
        </Box>
      </Modal>
      {/* Título Principal */}
      <Typography variant="h3" gutterBottom align="center">
        Panel de Reservas
      </Typography>

      {/* Reservas Activas */}
      <section>
        <Typography variant="h5" gutterBottom>
          Reservas Activas (IN)
        </Typography>
        <Paper elevation={3} sx={{ padding: 2, overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Nombre</strong>
                </TableCell>
                <TableCell>
                  <strong>Falta Pagar</strong>
                </TableCell>
                <TableCell>
                  <strong>Fecha Retiro</strong>
                </TableCell>
                <TableCell>
                  <strong>Habitación</strong>
                </TableCell>
                <TableCell>
                  <strong>Opciones De Pago</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.activeReservations.map((res, idx) => {
                // Convertimos "seña" y "total$" a números, y validamos que sean válidos
                const seña = parseFloat(res["seña"]) || 0; // Si no es numérico, asumimos 0
                const total = parseFloat(res["total$"]) || 0;

                // Determinamos la diferencia solo si "seña" no es "none"
                const diferencia = res["seña"] !== "none" ? total - seña : null;

                // Determinamos el color de fondo
                let backgroundColor;
                if (res["seña"] === "none") {
                  backgroundColor = "#FFC1C1"; // Rojo pastel
                } else if (diferencia > 0) {
                  backgroundColor = "#FFFACD"; // Amarillo pastel
                } else if (diferencia === 0) {
                  backgroundColor = "#C1FFC1"; // Verde pastel
                }

                return (
                  <TableRow key={idx}>
                    <TableCell>{res["nombre"]}</TableCell>
                    <TableCell sx={{ backgroundColor }}>{diferencia}</TableCell>
                    <TableCell>{res["fecha ret"]}</TableCell>
                    <TableCell>{res["nombre habitación"]}</TableCell>
                    <TableCell>
                      <Button
                        onClick={() => handleGenerateLink(res["idbeds"])}
                        variant="contained"
                      >
                        Completar Pago
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </section>

      <Divider sx={{ margin: "20px 0" }} />

      {/* Reservas Próximas */}
      <section>
        <Typography variant="h5" gutterBottom>
          Entra Mañana: ${totalPendiente}
        </Typography>
        {/* Mostrar total de pagos pendientes */}
        <Typography variant="h6" sx={{ marginTop: 2 }}></Typography>
        <Box sx={{ backgroundColor: "#f5f5f5", padding: 2, borderRadius: 2 }}>
          <Grid container spacing={2}>
            {/* Reservas que entran mañana */}
            {data.arrivedTomorow.map((res, idx) => (
              <Grid item xs={12} sm={6} md={4} key={`upcoming-${idx}`}>
                <Box
                  sx={{
                    backgroundColor: "#ffffff",
                    padding: 2,
                    borderRadius: 2,
                    boxShadow: 2,
                  }}
                >
                  <Typography variant="body1">
                    <strong>Nombre:</strong> {res["nombre"]}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha Ingreso:</strong> {res["fecha ingr"]}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Habitación:</strong> {res["nombre habitación"]}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Cantidad de Personas:</strong> {res["c. per"]}
                  </Typography>

                  <Typography variant="body2">
                    <strong>Pago Pendiente:</strong> $
                    {parseFloat(res["seña"].replace(/[^0-9.-]+/g, "")).toFixed(
                      2
                    )}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Próximas 10 Reservas */}
        <Typography variant="h5" gutterBottom sx={{ marginTop: 4 }}>
          Próximas Reservas
        </Typography>
        <Box sx={{ padding: 2, borderRadius: 2 }}>
          <Grid container spacing={2}>
            {data.nextReservations.map((res, idx) => {
              // Convertimos "seña" y "total$" a números
              const seña =
                res["seña"] !== "none"
                  ? parseFloat(res["seña"].replace(/[^0-9.-]+/g, "")) || 0
                  : null;
              const total =
                parseFloat(res["total$"].replace(/[^0-9.-]+/g, "")) || 0;

              // Determinamos la diferencia solo si "seña" no es "none"
              const diferencia = seña !== null ? total - seña : null;

              // Determinamos el color de fondo
              let backgroundColor;
              if (seña === null) {
                backgroundColor = "#FFC1C1"; // Rojo pastel para "none"
              } else if (diferencia > 0) {
                backgroundColor = "#FFFACD"; // Amarillo pastel para pagos incompletos
              } else if (diferencia === 0) {
                backgroundColor = "#C1FFC1"; // Verde pastel para pagos completos
              }

              return (
                <Grid item xs={12} sm={6} md={4} key={`next-${idx}`}>
                  <Box
                    sx={{
                      backgroundColor,
                      padding: 2,
                      borderRadius: 2,
                      boxShadow: 2,
                    }}
                  >
                    <Typography variant="body1">
                      <strong>Nombre:</strong> {res["nombre"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Fecha Ingreso:</strong> {res["fecha ingr"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Habitación:</strong> {res["nombre habitación"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Cantidad de Personas:</strong> {res["c. per"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Total:</strong> ${total.toFixed(2)}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Seña:</strong>{" "}
                      {seña !== null ? `$${seña.toFixed(2)}` : "No Verificada"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Debe:</strong>{" "}
                      {diferencia !== null
                        ? `$${diferencia.toFixed(2)}`
                        : "No Disponible"}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Source:</strong> {res["ingreso x"]}
                    </Typography>
                    <Button
                      onClick={() => handleGenerateLink(res["idbeds"])}
                      variant="contained"
                    >
                      Completar Pago
                    </Button>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </section>

      <Divider sx={{ margin: "20px 0" }} />

      {/* Resumen Financiero */}
      <section>
        <Typography variant="h5" gutterBottom>
          Resumen Financiero
        </Typography>
        <Box sx={{ padding: 2, backgroundColor: "#e3f2fd", borderRadius: 2 }}>
          <Typography variant="h6">
            Ingresos Totales: {formatCurrency(data.totalIncome)}
          </Typography>
          <Typography variant="h6">
            Pagos Pendientes: {formatCurrency(data.paymentsPending)}
          </Typography>
          <Typography variant="h6">
            Dinero en caja:{" "}
            {formatCurrency(data.totalIncome - data.paymentsPending)}
          </Typography>
        </Box>
      </section>

      {/* Reservas que deben salir hoy */}
      <section>
        <Typography variant="h5" gutterBottom>
          Se Van Hoy
        </Typography>
        <Box sx={{ backgroundColor: "#f5f5f5", padding: 2, borderRadius: 2 }}>
          <Grid container spacing={2}>
            {data.outToday.map((res, idx) => {
              return (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Box
                    sx={{
                      backgroundColor: "#ffffff",
                      padding: 2,
                      borderRadius: 2,
                      boxShadow: 2,
                    }}
                  >
                    <Typography variant="body1">
                      <strong>Nombre:</strong> {res["nombre"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Fecha Ingreso:</strong> {res["fecha ingr"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Habitación:</strong> {res["nombre habitación"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Cantidad de Personas:</strong> {res["c. per"]}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Pago Pendiente:</strong> $
                      {parseFloat(
                        res["seña"].replace(/[^0-9.-]+/g, "")
                      ).toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </section>

      {/* Reservas que deben salir mañana */}
      <section>
        <Typography variant="h5" gutterBottom>
          Se Van Mañana
        </Typography>
        <Box sx={{ backgroundColor: "#f5f5f5", padding: 2, borderRadius: 2 }}>
          <Grid container spacing={2}>
            {data.outTomorrow.map((res, idx) => {
              return (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Box
                    sx={{
                      backgroundColor: "#ffffff",
                      padding: 2,
                      borderRadius: 2,
                      boxShadow: 2,
                    }}
                  >
                    <Typography variant="body1">
                      <strong>Nombre:</strong> {res["nombre"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Fecha Ingreso:</strong> {res["fecha ingr"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Habitación:</strong> {res["nombre habitación"]}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Cantidad de Personas:</strong> {res["c. per"]}
                    </Typography>

                    <Typography variant="body2">
                      <strong>Pago Pendiente:</strong> $
                      {parseFloat(
                        res["seña"].replace(/[^0-9.-]+/g, "")
                      ).toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </section>
    </Box>
  );
}

export default PanelPage;
